<template>
  <TemplateModal ref="modal" center width="800" empty>
    <template v-slot:activator>
      <BaseTooltip
        :tooltip="
          type === 'project'
            ? localStorage.translations.pages.pages.buttons.proekty
            : type === 'manager'
            ? localStorage.translations.pages.sales_project['planned_resources-labels']['rukovoditel-proekta']
            : type === 'sales'
            ? localStorage.translations.pages.sales_project['planned_resources-labels']['rukovoditel-prodazh']
            : localStorage.translations.pages.sales_project['planned_resources-responsible_employees'].main
        "
      >
        <button class="open" @click.stop.prevent="onOpenModal">
          <svg
            v-if="type === 'project'"
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 4.50001C14.448 4.50001 14 4.05201 14 3.50001V2.00001H10.0001V3.50001C10.0001 4.05201 9.55206 4.50001 9.00006 4.50001C8.44806 4.50001 8.00006 4.05201 8.00006 3.50001V2.00001C8.00006 0.897008 8.89706 7.62939e-06 10.0001 7.62939e-06H14C15.103 7.62939e-06 16 0.897008 16 2.00001V3.50001C16 4.05201 15.552 4.50001 15 4.50001Z"
              fill="#2D9CDB"
            />
            <path
              d="M12.71 13.38C12.53 13.45 12.27 13.5 12 13.5C11.73 13.5 11.47 13.45 11.23 13.36L0 9.62V17.25C0 18.77 1.23 20 2.75 20H21.25C22.77 20 24 18.77 24 17.25V9.62L12.71 13.38Z"
              fill="#2D9CDB"
            />
            <path
              d="M24 5.75001V8.04001L12.24 11.96C12.16 11.99 12.08 12 12 12C11.92 12 11.84 11.99 11.76 11.96L0 8.04001V5.75001C0 4.23001 1.23 3.00001 2.75 3.00001H21.25C22.77 3.00001 24 4.23001 24 5.75001Z"
              fill="#2D9CDB"
            />
          </svg>
          <svg
            v-else-if="type === 'manager'"
            width="21"
            height="24"
            viewBox="0 0 21 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.8491 14.0234L11.9286 21.5L10.6429 16.1875L11.9286 14H8.07143L9.35714 16.1875L8.07143 21.5L6.15089 14.0234C3.28616 14.1562 1 16.4336 1 19.25V20.875C1 21.9102 1.86384 22.75 2.92857 22.75H17.0714C18.1362 22.75 19 21.9102 19 20.875V19.25C19 16.4336 16.7138 14.1562 13.8491 14.0234Z"
              fill="#2D9CDB"
            />
            <path
              d="M7.61323 0.710283C7.68404 1.02622 7.75246 1.32776 7.81903 1.6295C7.91052 2.04312 8.00016 2.4559 8.09139 2.87038C8.1317 3.05303 8.30647 3.16216 8.50882 3.13249C8.71116 3.10283 8.82441 2.96064 8.78542 2.78096C8.61569 1.99884 8.44543 1.21651 8.26854 0.435451C8.25936 0.39767 8.26053 0.358747 8.27197 0.321362C8.28342 0.283977 8.30487 0.249017 8.33484 0.218891C8.45816 0.081157 8.62656 0.00211898 8.83873 0.00148329C9.61205 -0.00049443 10.3854 -0.00049443 11.1587 0.00148329C11.2432 0.00128646 11.3269 0.0154045 11.4041 0.0429072C11.4813 0.0704099 11.5503 0.110673 11.6066 0.161043C11.7074 0.245802 11.757 0.337342 11.7273 0.466176C11.5549 1.21206 11.3937 1.95964 11.2295 2.70679C11.2136 2.76178 11.2053 2.81798 11.2046 2.8744C11.2096 2.94206 11.2453 3.00595 11.3049 3.05417C11.3645 3.10239 11.444 3.13166 11.5287 3.13652C11.7114 3.14669 11.8665 3.04985 11.9031 2.89368C11.9625 2.64025 12.0156 2.38598 12.0713 2.1317C12.1704 1.67965 12.2698 1.2276 12.3693 0.775548C12.3731 0.758596 12.381 0.74228 12.3914 0.711979C12.4444 0.731685 12.4903 0.74673 12.5338 0.766648C14.26 1.56699 15.1964 2.75849 15.3051 4.35494C15.312 4.45601 15.3343 4.50326 15.4706 4.53399C15.77 4.6001 15.948 4.7728 15.9909 5.01797C16.0368 5.27224 15.9076 5.47122 15.6287 5.59285C15.4926 5.65083 15.3452 5.68975 15.1927 5.70791C14.0039 5.84958 12.8062 5.93794 11.605 5.97257C10.173 6.01601 8.74087 6.01368 7.3125 5.92298C6.45006 5.8681 5.59108 5.77847 4.73183 5.69583C4.59697 5.67999 4.46752 5.64251 4.35127 5.58564C4.08315 5.4585 3.96089 5.26059 4.01101 5.01161C4.06114 4.76263 4.24704 4.59269 4.55255 4.52975C4.67242 4.50496 4.68781 4.463 4.69311 4.38015C4.79919 2.75235 5.75259 1.54537 7.52307 0.744611C7.54508 0.733168 7.56948 0.7266 7.61323 0.710283Z"
              fill="#2D9CDB"
            />
            <path
              d="M15 7C14.9802 7.22638 14.9677 7.44704 14.9407 7.66579C14.7823 8.94835 14.3496 10.123 13.5439 11.1427C12.8492 12.0226 11.9832 12.6582 10.8731 12.8984C9.5304 13.1894 8.33145 12.8459 7.27792 11.9886C6.22004 11.1274 5.58102 9.99226 5.24941 8.68464C5.12302 8.18639 5.08116 7.66661 5.00288 7.15637C4.99904 7.10477 4.99904 7.05296 5.00288 7.00136C8.32222 7.41952 11.6808 7.41906 15 7Z"
              fill="#2D9CDB"
            />
          </svg>
          <svg
            v-else-if="type === 'responsible'"
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.9962 23.1108H19.7209V17.1179C20.7366 17.829 21.5451 18.6972 22.1322 19.7687C22.6969 20.7922 22.9941 21.9418 22.9962 23.1108Z"
              fill="#2D9CDB"
            />
            <g>
              <path
                d="M8.72257 1.03319C8.80487 1.49276 8.88439 1.93137 8.96176 2.37029C9.0681 2.97196 9.17228 3.57239 9.27831 4.17529C9.32516 4.44098 9.52828 4.59972 9.76346 4.55657C9.99864 4.51342 10.1303 4.3066 10.0849 4.04522C9.88768 2.90754 9.6898 1.76955 9.48421 0.633413C9.47353 0.578457 9.47489 0.521839 9.48819 0.467458C9.50149 0.413077 9.52642 0.362224 9.56126 0.318402C9.70459 0.118052 9.90032 0.0030823 10.1469 0.00215761C11.0457 -0.000719204 11.9445 -0.000719204 12.8433 0.00215761C12.9416 0.0018713 13.0387 0.0224077 13.1285 0.0624134C13.2182 0.102419 13.2985 0.160986 13.3639 0.234255C13.481 0.357547 13.5387 0.490703 13.5042 0.678107C13.3038 1.76308 13.1164 2.85051 12.9256 3.93734C12.9072 4.01732 12.8974 4.09907 12.8966 4.18115C12.9025 4.27957 12.9439 4.3725 13.0132 4.44264C13.0825 4.51278 13.1749 4.55535 13.2733 4.56243C13.4857 4.57722 13.666 4.43636 13.7085 4.20919C13.7776 3.84055 13.8392 3.47067 13.9039 3.1008C14.0192 2.44324 14.1347 1.78568 14.2504 1.12812C14.2547 1.10346 14.2639 1.07973 14.276 1.03565C14.3376 1.06432 14.3909 1.0862 14.4415 1.11518C16.4478 2.27936 17.5361 4.01254 17.6625 6.33475C17.6705 6.48178 17.6964 6.55051 17.8548 6.59521C18.2028 6.69137 18.4096 6.94258 18.4596 7.2992C18.5129 7.66908 18.3628 7.95851 18.0385 8.13543C17.8804 8.21978 17.709 8.27639 17.5318 8.3028C16.1502 8.50888 14.7581 8.6374 13.3621 8.68778C11.6976 8.75097 10.0332 8.74758 8.37304 8.61566C7.37067 8.53583 6.37231 8.40544 5.37364 8.28523C5.2169 8.26219 5.06645 8.20767 4.93133 8.12495C4.61971 7.94002 4.47762 7.65213 4.53587 7.28996C4.59413 6.92779 4.8102 6.68059 5.16528 6.58904C5.3046 6.55298 5.32248 6.49195 5.32864 6.37143C5.45193 4.0036 6.56002 2.24792 8.61777 1.08312C8.64335 1.06648 8.67171 1.05692 8.72257 1.03319Z"
                fill="#2D9CDB"
              />
              <path
                d="M17.353 23.1108H5.64026C5.63718 23.0538 5.63194 22.9998 5.63194 22.9459C5.63194 20.6757 5.6306 18.405 5.62793 16.134C5.62793 16.0033 5.66892 15.9531 5.78883 15.9287C6.196 15.8458 6.60101 15.754 7.0085 15.6726C7.05041 15.664 7.12501 15.6889 7.14597 15.7225C7.73623 16.6552 8.61561 17.1891 9.64263 17.4856C11.2889 17.9597 12.8942 17.8493 14.4224 17.0353C15.0025 16.727 15.4842 16.3001 15.8362 15.7364C15.8537 15.7151 15.8759 15.6982 15.9012 15.6871C15.9264 15.6761 15.9539 15.6712 15.9814 15.6729C16.3987 15.7558 16.8136 15.8498 17.2307 15.9367C17.3265 15.9565 17.3617 15.9984 17.3617 16.1023C17.3586 18.3984 17.3576 20.6943 17.3589 22.99C17.3607 23.0263 17.3558 23.0615 17.353 23.1108Z"
                fill="#2D9CDB"
              />
              <path
                d="M17.1721 9.19235C17.1496 9.44849 17.1355 9.69816 17.105 9.94566C16.9253 11.3968 16.4346 12.7259 15.521 13.8796C14.7331 14.8752 13.7511 15.5943 12.4923 15.8661C10.9696 16.1953 9.61002 15.8066 8.41531 14.8366C7.21568 13.8623 6.49103 12.5779 6.11499 11.0984C5.97166 10.5347 5.92419 9.94659 5.83542 9.36928C5.83106 9.3109 5.83106 9.25227 5.83542 9.19389C9.59956 9.66702 13.4081 9.6665 17.1721 9.19235Z"
                fill="#2D9CDB"
              />
              <path
                d="M3.27643 17.141V23.1049H-0.000361294C-0.00156826 22.099 0.219459 21.1052 0.646922 20.1946C1.19495 19.0083 2.51942 17.4689 3.27643 17.141Z"
                fill="#2D9CDB"
              />
            </g>
          </svg>
          <svg v-else-if="type === 'sales'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_636_12)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.6783 0.999897L9.61323 0.710283C9.59821 0.715885 9.58547 0.720338 9.57433 0.724234C9.55301 0.731685 9.53753 0.737097 9.52307 0.744611C7.75259 1.54537 6.79919 2.75235 6.69311 4.38015C6.68781 4.463 6.67242 4.50496 6.55255 4.52975C6.24704 4.59269 6.06114 4.76263 6.01101 5.01161C5.96089 5.26059 6.08315 5.4585 6.35127 5.58564C6.46752 5.64251 6.59697 5.67999 6.73183 5.69583C6.87468 5.70957 7.01752 5.7235 7.16038 5.73743L7.16137 5.73753H7.16138L7.16139 5.73753C7.87746 5.80738 8.59378 5.87724 9.3125 5.92298C10.7409 6.01368 12.173 6.01601 13.605 5.97257C14.8062 5.93794 16.0039 5.84958 17.1927 5.70791C17.3452 5.68975 17.4926 5.65083 17.6287 5.59285C17.9076 5.47122 18.0368 5.27224 17.9909 5.01797C17.948 4.7728 17.77 4.6001 17.4706 4.53399C17.3343 4.50326 17.312 4.45601 17.3051 4.35494C17.1964 2.75849 16.26 1.56699 14.5338 0.766648C14.5019 0.752058 14.4688 0.740082 14.4325 0.726974L14.3914 0.711979C14.3873 0.723885 14.3836 0.733632 14.3804 0.742106L14.3804 0.742126L14.3804 0.742142C14.3754 0.755218 14.3716 0.765266 14.3693 0.775548C14.2698 1.2276 14.1704 1.67965 14.0713 2.1317C14.0554 2.20408 14.0398 2.27647 14.0242 2.34883L14.024 2.34941L14.0239 2.34999C13.9847 2.53144 13.9455 2.71278 13.9031 2.89368C13.8665 3.04985 13.7114 3.14669 13.5287 3.13652C13.444 3.13166 13.3645 3.10239 13.3049 3.05417C13.2453 3.00595 13.2096 2.94206 13.2046 2.8744C13.2053 2.81798 13.2136 2.76178 13.2295 2.70679L13.3332 2.23384L13.3332 2.23377L13.3332 2.23372C13.4622 1.64418 13.5913 1.05465 13.7273 0.466176C13.757 0.337342 13.7074 0.245802 13.6066 0.161043C13.5503 0.110673 13.4813 0.0704099 13.4041 0.0429072C13.3269 0.0154045 13.2432 0.00128646 13.1587 0.00148329C12.3854 -0.00049443 11.6121 -0.00049443 10.8387 0.00148329C10.6266 0.00211898 10.4582 0.081157 10.3348 0.218891C10.3049 0.249017 10.2834 0.283977 10.272 0.321362C10.2605 0.358747 10.2594 0.39767 10.2685 0.435451C10.4454 1.21651 10.6157 1.99884 10.7854 2.78096C10.8244 2.96064 10.7112 3.10283 10.5088 3.13249C10.3065 3.16216 10.1317 3.05303 10.0914 2.87038C10.0529 2.69543 10.0147 2.52079 9.97646 2.34626C9.92416 2.10729 9.87191 1.86854 9.81903 1.6295C9.77306 1.42114 9.72621 1.21287 9.6783 0.999897ZM16.9826 7.21489C16.9881 7.14376 16.9937 7.07217 17 7C13.6808 7.41906 10.3222 7.41952 7.00288 7.00136C6.99904 7.05296 6.99904 7.10477 7.00288 7.15637C7.02646 7.3101 7.04674 7.46469 7.06702 7.6193L7.06703 7.61934C7.11406 7.97788 7.1611 8.33652 7.24941 8.68464C7.58102 9.99226 8.22004 11.1274 9.27792 11.9886C10.3314 12.8459 11.5304 13.1894 12.8731 12.8984C13.9832 12.6582 14.8492 12.0226 15.5439 11.1427C16.3496 10.123 16.7823 8.94835 16.9407 7.66579C16.9591 7.51678 16.9708 7.36688 16.9826 7.21489ZM15.8491 14.0234L13.9286 21.5L12.6429 16.1875L13.9286 14H10.0714L11.3571 16.1875L10.0714 21.5L8.9849 17.2703L8.59927 17.5959C8.52219 17.5184 8.44203 17.4453 8.35909 17.3765L8.09927 17.5959C8.02219 17.5184 7.94203 17.4453 7.85909 17.3765L7.59927 17.5959C7.09684 17.0909 6.46371 16.7689 5.77932 16.6632C5.23336 16.7475 4.72016 16.9696 4.27979 17.3125H4.99597H5.496H5.99602V18.4375H5.99597V19.4375H5.49597H4.99597H3.02746C3.02404 19.4582 3.02069 19.479 3.01746 19.4998C3.02071 19.5207 3.02407 19.5416 3.02752 19.5625H4.99597H5.496H5.99602V20.6875H5.99597V21.6875H5.49597H4.99597H4.27958C4.71996 22.0306 5.23318 22.2525 5.77917 22.3368C6.46359 22.2312 7.09668 21.9091 7.59866 21.4041L7.8586 21.6236C7.94153 21.5548 8.02166 21.4816 8.0987 21.4041L8.35863 21.6236C8.44156 21.5548 8.52168 21.4816 8.59872 21.4041L9.49942 22.1646C9.32977 22.3351 9.14888 22.4905 8.95837 22.63L8.0987 21.9041C7.4764 22.5302 6.6526 22.875 5.7793 22.875C4.9061 22.875 4.0829 22.5308 3.46 21.9041C3.2509 21.6874 3.0734 21.4465 2.9318 21.1875H5.496V20.0625H2.5275C2.497 19.878 2.4732 19.6912 2.4732 19.5C2.4732 19.3088 2.497 19.122 2.5275 18.9375H5.496V17.8125H2.9318C3.0784 17.5554 3.2469 17.3102 3.46 17.0959C4.0829 16.4698 4.9061 16.125 5.7793 16.125C6.6526 16.125 7.4764 16.4698 8.0993 17.0959L9 16.3354C8.1426 15.4742 6.9988 15 5.7793 15C4.5592 15 3.4161 15.4742 2.5599 16.3359C2.1334 16.7655 1.801 17.2668 1.581 17.8125H0V18.9375H1.2909C1.2677 19.1231 1.2519 19.3104 1.2519 19.5C1.2519 19.6896 1.2677 19.8769 1.2909 20.0625H0V21.1875H1.581C1.8021 21.7331 2.1312 22.2343 2.5599 22.6646C3.4161 23.5258 4.5592 24 5.7793 24C6.9788 24 8.10506 23.5412 8.95701 22.7067L9.00833 22.75H19.0714C20.1362 22.75 21 21.9102 21 20.875V19.25C21 16.4336 18.7138 14.1562 15.8491 14.0234ZM8.15086 14.0234L8.40815 15.025C7.76096 14.6819 7.03466 14.5 6.27932 14.5C6.23022 14.5 6.18124 14.5008 6.1324 14.5023C6.75092 14.2248 7.43271 14.0567 8.15086 14.0234Z" fill="#2D9CDB"/>
            </g>
            <defs>
              <clipPath id="clip0_636_12">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <div class="circle" :data-text="projects_count" />
        </button>
      </BaseTooltip>
    </template>
    <div class="projects_grid">
      <div
        v-for="(project, key) in projects"
        :key="key"
        class="projects_body"
        @click="deleteId = project.id"
      >
        <router-link
          class="projects_item f16"
          :to="{
            name: 'ProjectsProjectShow',
            params: { id: project.id },
          }"
        >
          <BaseIcon icon="pages-projects" color="#277FAF" />
          <div class="projects_item_texts">
            {{ project.name }}
          </div>
        </router-link>
      </div>
    </div>
  </TemplateModal>
</template>

<script>
import TemplateModal from 'components/templates/TemplateModal'
import { mapActions } from 'vuex'

export default {
  name: 'EmployeesProjectsModal',
  props: {
    projects: {
      type: [Array, Object],
      default: () => [],
    },
    type: {
      default: 'project',
      type: String,
    },
    projects_count: [Number, String],
    onDownloadPageData: Function,
  },
  components: {
    TemplateModal,
  },
  data: () => ({
    deleteId: null,
  }),
  computed: {
    modalShow() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
  },
  methods: {
    ...mapActions('workClientProjectsSubscribers', ['onWorkClientProjectsSubscribersDelete']),
    onOpenModal() {
      this.$refs.modal.openModal()
    },
    onDeleteSubscribers(id) {
      this.onWorkClientProjectsSubscribersDelete({ id })
        .then((response) => {
          console.log(response)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.onDownloadPageData()
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.open {
  width: max-content;
  height: max-content;
  position: relative;
  transition: 0.3s;
  .circle {
    // background: #EBFFF3;
    // background: #f2f2f2;

    // width: 100%;
    position: absolute;
    left: 70%;
    bottom: -10%;
    // padding: 3px;
    // height: max-content;
    // line-height: 1;

    &::before {
      background: #ffffff;
      border-radius: 50%;
      min-width: 15px;
      content: attr(data-text);
      // content: '';
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 10px;
      padding: 3px;
      // padding-top: 100%;
      color: #277faf;
    }
  }

  &:hover {
    svg {
      filter: brightness(0.5);
    }
  }
}
.projects {
  &_grid {
    width: 100%;
    display: grid;
    gap: 18px;
  }
  &_body {
    display: grid;
    grid-template-columns: 1fr 50px;
    border: 1px solid #277faf;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background: #277faf;
      :deep().projects_item {
        background: #277faf;
        color: #ffffff;
        svg {
          filter: brightness(0) invert(1);
        }
      }
    }
  }
  &_item {
    background: #ffffff;
    border-radius: 4px;
    width: 100%;
    padding: 15px 25px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #333333;
    transition: 0.3s;
  }
}
</style>
